var _path, _g, _path2, _g2, _rect, _g3, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTip6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 399,
    viewBox: "0 0 405 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H378C392.912 0 405 12.0883 405 27V372C405 386.912 392.912 399 378 399H26C11.6406 399 0 387.359 0 373V0Z",
    fill: "url(#paint0_radial_1_4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 114,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 142,
    width: 122,
    height: 13,
    rx: 6.5,
    fill: "#B6D2D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 182,
    width: 232,
    height: 6,
    rx: 3,
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 223,
    width: 232,
    height: 6,
    rx: 3,
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 202,
    width: 232,
    height: 6,
    rx: 3,
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 243,
    width: 232,
    height: 6,
    rx: 3,
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 275,
    width: 49,
    height: 23,
    rx: 8,
    fill: "#EEAAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 289.5,
    r: 11.5,
    fill: "#FF3333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 289.5,
    r: 22.5,
    fill: "#FF3333",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 289.5,
    r: 2.5,
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 289.5,
    r: 2.5,
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 289.5,
    r: 2.5,
    fill: "#FF3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3421 289.061C99.1634 288.996 98.9699 288.984 98.7842 289.025C98.5986 289.066 98.4285 289.159 98.2939 289.293C98.1594 289.428 98.0659 289.598 98.0245 289.783C97.9831 289.969 97.9954 290.162 98.0601 290.341L102.06 301.341C102.129 301.532 102.255 301.696 102.42 301.814C102.585 301.931 102.781 301.996 102.984 301.999C103.186 302.002 103.385 301.944 103.554 301.832C103.722 301.72 103.853 301.559 103.928 301.371L105.365 297.78L109.293 301.707C109.385 301.803 109.496 301.879 109.618 301.931C109.74 301.984 109.871 302.011 110.004 302.012C110.137 302.014 110.268 301.988 110.391 301.938C110.514 301.888 110.626 301.814 110.72 301.72C110.813 301.626 110.888 301.514 110.938 301.391C110.988 301.268 111.014 301.137 111.012 301.004C111.011 300.871 110.984 300.74 110.931 300.618C110.879 300.496 110.803 300.385 110.707 300.293L106.779 296.365L110.371 294.929C110.559 294.854 110.72 294.724 110.833 294.555C110.945 294.386 111.004 294.187 111 293.984C110.997 293.782 110.932 293.585 110.815 293.42C110.697 293.255 110.532 293.129 110.341 293.06L99.3411 289.06L99.3421 289.061Z",
    fill: "#454545"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.497 187.297L235.578 219.823L269.706 213.882L247.497 187.297ZM246.805 204.783C247.079 208.535 247.209 212.336 247.178 216.155L253.178 216.202C253.21 212.217 253.075 208.254 252.789 204.346L246.805 204.783ZM246.607 227.503C246.251 231.273 245.727 235.025 245.019 238.726L250.913 239.852C251.658 235.955 252.208 232.015 252.58 228.066L246.607 227.503ZM242.321 249.695C241.219 253.307 239.917 256.832 238.402 260.239L243.884 262.677C245.505 259.033 246.891 255.277 248.06 251.445L242.321 249.695ZM233.164 270.132C231.196 273.285 228.998 276.286 226.557 279.104L231.093 283.032C233.747 279.967 236.128 276.714 238.254 273.31L233.164 270.132ZM218.619 286.878C215.822 289.193 212.788 291.321 209.5 293.231L212.514 298.419C216.09 296.341 219.396 294.024 222.446 291.499L218.619 286.878ZM199.441 298.06C196.102 299.361 192.55 300.474 188.773 301.377L190.168 307.212C194.202 306.248 198.017 305.054 201.619 303.651L199.441 298.06ZM177.682 303.33C174.093 303.753 170.332 304.008 166.392 304.082L166.505 310.081C170.632 310.004 174.59 309.736 178.384 309.288L177.682 303.33ZM154.99 303.809C151.354 303.575 147.586 303.201 143.68 302.678L142.884 308.625C146.919 309.165 150.825 309.554 154.605 309.796L154.99 303.809ZM132.405 300.819C130.536 300.456 128.64 300.062 126.715 299.635L125.416 305.493C127.391 305.931 129.339 306.336 131.261 306.709L132.405 300.819Z",
    fill: "url(#paint1_linear_1_4)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 91,
    width: 160,
    height: 100,
    rx: 15,
    fill: "white",
    fillOpacity: 0.7
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 83,
    width: 186,
    height: 116,
    rx: 15,
    fill: "white",
    fillOpacity: 0.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 96,
    width: 144,
    height: 90,
    rx: 15,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.541 178.764H237.812V181H236.551V178.764H231.494V177.854L236.148 171.9H237.552L233.093 177.646H236.59V175.67H237.812V177.646H239.541V178.764Z",
    fill: "#DAE2ED",
    fillOpacity: 0.82
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.704 165.317C252.004 165.317 253.691 165.754 254.764 166.628C255.853 167.487 256.397 168.667 256.397 170.17C256.397 171.121 256.167 171.979 255.707 172.746C255.262 173.497 254.58 174.095 253.66 174.54C252.755 174.969 251.636 175.184 250.302 175.184C249.167 175.184 248.071 175.015 247.013 174.678C245.955 174.325 245.081 173.842 244.391 173.229L245.449 171.412C246.001 171.933 246.706 172.355 247.565 172.677C248.424 172.984 249.328 173.137 250.279 173.137C251.49 173.137 252.426 172.884 253.085 172.378C253.76 171.857 254.097 171.151 254.097 170.262C254.097 169.296 253.729 168.568 252.993 168.077C252.257 167.571 251 167.318 249.221 167.318H245.564L246.415 158.9H255.5V160.901H248.347L247.91 165.317H249.704Z",
    fill: "#909EB5",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.04 130.44C259.827 130.44 261.453 130.8 262.92 131.52C264.387 132.24 265.547 133.267 266.4 134.6C267.253 135.907 267.68 137.427 267.68 139.16C267.68 141.027 267.213 142.667 266.28 144.08C265.347 145.493 264.067 146.587 262.44 147.36C260.84 148.107 259.053 148.48 257.08 148.48C253.16 148.48 250.093 147.28 247.88 144.88C245.667 142.48 244.56 139.053 244.56 134.6C244.56 131.427 245.16 128.707 246.36 126.44C247.56 124.173 249.227 122.453 251.36 121.28C253.52 120.107 256.013 119.52 258.84 119.52C260.333 119.52 261.76 119.693 263.12 120.04C264.507 120.36 265.68 120.827 266.64 121.44L264.24 126.2C262.853 125.267 261.107 124.8 259 124.8C256.627 124.8 254.747 125.493 253.36 126.88C251.973 128.267 251.227 130.28 251.12 132.92C252.773 131.267 255.08 130.44 258.04 130.44ZM256.72 143.64C258.107 143.64 259.227 143.267 260.08 142.52C260.96 141.773 261.4 140.76 261.4 139.48C261.4 138.2 260.96 137.187 260.08 136.44C259.227 135.667 258.08 135.28 256.64 135.28C255.227 135.28 254.067 135.68 253.16 136.48C252.253 137.253 251.8 138.253 251.8 139.48C251.8 140.707 252.24 141.707 253.12 142.48C254 143.253 255.2 143.64 256.72 143.64Z",
    fill: "#2C2C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4",
    x: 149,
    y: 71,
    width: 224,
    height: 164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4",
    x: 157,
    y: 76,
    width: 208,
    height: 154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265 132.5) rotate(-153.236) scale(321.996 326.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EEBB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4",
    x1: 248.906,
    y1: 202.278,
    x2: 142.143,
    y2: 311.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EFF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 114,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip6);
export default __webpack_public_path__ + "static/media/tip6.eb40d6bb667578a3dd8cf6a01bc297ca.svg";
export { ForwardRef as ReactComponent };